<script setup>
import { defineAsyncComponent } from 'vue'
import BaseWave from '@/components/general/BaseWave.vue'

const FooterHead = defineAsyncComponent(() => import('./FooterHead.vue'))
const FooterBody = defineAsyncComponent(() => import('./FooterBody.vue'))
const FooterBottom = defineAsyncComponent(() => import('./FooterBottom.vue'))
const FooterCustomerCare = defineAsyncComponent(() => import('./FooterCustomerCare.vue'))

const scrollUp = () => { window.scrollTo({ top: 0, behavior: 'smooth' }) };
</script>

<template>
  <div class="mt-auto" />
  <BaseWave
    color="text-primary"
    path="footer"
    class="relative"
  />
  <footer class="footer relative pt-6 bg-primary">
    <span
      class="footer__scrollup lg:hidden btn p-2 text-light rounded-circle shadow-none bg-primary"
      aria-label="Scroll up"
      @click="scrollUp"
    >
      <i class="mi-arrow-u icon-20" />
    </span>
    <div class="container px-4 sm:px-0">
      <FooterHead />
      <FooterBody />
      <hr class="bg-light mt-6 mb-6">
      <FooterCustomerCare />
      <hr class="bg-light mt-4 mb-4">
      <FooterBottom />
    </div>
  </footer>
</template>